// efs rebrand data

import hero from "../../assets/images/efs/hero.webp";
import mockup from "../../assets/images/efs/mockup.webp";
import logo from "../../assets/images/efs/logo.webp";

const efsRebrandData = {
  id: "2",
  title: "Global Brand Revamp & Packaging Redesign for Economic Food Solutions",
  subtitle:
    "A comprehensive brand transformation project covering modern logo design, website redevelopment, and globally compliant packaging systems tailored for multi-country export standards.",
  client: "Economic Food Solutions",
  year: "Ongoing",
  role: "Brand Strategist · UI/UX Designer · Packaging Systems Research · Web Developer",
  heroImage: hero,
  skills: [
    "Brand Identity Design",
    "Packaging Design",
    "Global Compliance Research",
    "Web Development",
    "UI/UX Strategy",
  ],

  link: null,

  sections: [
    {
      title: "Brand Identity Revamp",
      body:
        "• Led a **complete brand transformation** to modernize Economic Food Solutions’ visual identity and market positioning.\n\n" +
        "• Designed a **contemporary, scalable logo system** aligned with global FMCG standards and adaptable across print, digital, and packaging assets.\n\n" +
        "• Established a cohesive **brand guideline system (typography, color palette, spacing, tone, and usage rules)** to ensure long-term consistency.\n\n" +
        "• Designed and developed a **modern, responsive corporate website** reflecting the new brand direction and improving product visibility.\n\n" +
        "• Currently ongoing — continuously refining brand assets and expanding digital presence.",
      image: logo,
    },

    {
      title: "Global Packaging Redesign & International Compliance Integration",
      body:
        "• Conducted in-depth research on **international food packaging regulations and labeling standards** across multiple export regions.\n\n" +
        "• Designed a **globally adaptable packaging system** that aligns with varying country-specific compliance requirements.\n\n" +
        "• Developed **three distinct Nutrition Facts label formats** to meet international regulatory variations.\n\n" +
        "• Structured packaging layouts to accommodate **multilingual content, export certifications, barcode standards, and manufacturing disclosures**.\n\n" +
        "• Created a unified yet flexible **modular packaging framework** allowing seamless adaptation for different markets.\n\n" +
        "• Strengthened expertise in **regulatory research, export documentation alignment, and production-ready packaging systems**.",
      image: mockup,
    },
  ],
};

export default efsRebrandData;